module.exports = __webpack_public_path__ + "ae6636759001a887a018734bcf2a87a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-2.png
// module id = 2005
// module chunks = 0